import React from 'react';

interface AlreadyLoggedInModalProps {
  isOpen: boolean;
  onClose: () => void;
  username: string;
  onForceLogout: () => void;
}

const AlreadyLoggedInModal: React.FC<AlreadyLoggedInModalProps> = ({
  isOpen,
  onClose,
  username,
  onForceLogout,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
      <div className="w-full max-w-sm bg-white rounded-2xl shadow-2xl overflow-hidden">
        <div className="p-6 text-center">

          {/* Icon */}
          <div className="w-14 h-14 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-7 h-7 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
            </svg>
          </div>

          <h3 className="text-base font-semibold text-gray-900 mb-1">Already Logged In</h3>
          <p className="text-sm text-gray-500 leading-relaxed">
            <span className="font-medium text-gray-700">{username}</span> is already active on another device. Sign out from all devices and continue?
          </p>

          <div className="flex gap-3 mt-6">
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2.5 border border-gray-300 rounded-xl text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={onForceLogout}
              className="flex-1 px-4 py-2.5 bg-[#B98027] text-white rounded-xl text-sm font-semibold hover:bg-[#a06f20] transition-colors"
            >
              Sign Out & Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlreadyLoggedInModal;
